/**
 * Posts the newsletter signup form to the operations center's public
 * /api/signup endpoint instead of Shopify's native customer-creation form —
 * this is the "Shopify" side of the ops center's unified double opt-in
 * capture (see pl-email-cta.liquid). No page reload; the form's own message
 * element is toggled success/error based on the response.
 */
(function () {
  function showMessage(form, text, kind) {
    var message = form.querySelector('[id$="-message"]');
    if (!message) return;
    message.textContent = text;
    message.hidden = false;
    message.classList.remove('pl-email-cta__message--success', 'pl-email-cta__message--error');
    message.classList.add('pl-email-cta__message--' + kind);
  }

  function handleSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var endpoint = form.dataset.endpoint;
    var emailInput = form.querySelector('input[name="email"]');
    var honeypot = form.querySelector('input[name="company"]');
    var button = form.querySelector('button[type="submit"]');

    // Honeypot: real people never fill this hidden field. Accept silently
    // so bots don't learn the form rejected them — no request sent at all.
    if (honeypot && honeypot.value.trim().length > 0) {
      showMessage(form, form.dataset.successMessage, 'success');
      form.reset();
      return;
    }

    if (!endpoint || endpoint.indexOf('/api/signup') === 0) {
      // Blank ops_center_url section setting — fails loudly to whoever's
      // looking at the page (console), quietly to the visitor (generic error).
      console.error('[pl-email-cta] ops_center_url section setting is not configured');
      showMessage(form, form.dataset.errorMessage, 'error');
      return;
    }

    var originalButtonText = button ? button.textContent : null;
    if (button) {
      button.disabled = true;
      button.textContent = '…';
    }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: emailInput.value, source: 'SHOPIFY', company: honeypot ? honeypot.value : '' }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('signup request failed: ' + res.status);
        showMessage(form, form.dataset.successMessage, 'success');
        form.reset();
      })
      .catch(function (err) {
        console.error('[pl-email-cta] signup error', err);
        showMessage(form, form.dataset.errorMessage, 'error');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      });
  }

  document.querySelectorAll('form[data-pl-email-cta]').forEach(function (form) {
    form.addEventListener('submit', handleSubmit);
  });
})();
